module.exports = __webpack_public_path__ + "img/apiIntegration.8e23125a.png";